const secrets = {
  api: {
    baseUri: process.env.REACT_APP_BASE_URI
  },
  pti: {
    token: 'T9ukl7w6UvrXyR0HlGHkZj5ZNAlcqwiy',
    issueUrl: 'https://preflighttech.com/api/1/issues'
  },
  app: {
    name: 'el-seller',
  }
};

export default secrets;
